module.exports = __webpack_public_path__ + "fc5cd68cd29ee23663acb26d3cd7edc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/team_clemens_mobile_teaser.jpg
// module id = 666
// module chunks = 0